<template>
  <el-dialog :title="titleList[popType]" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="150px">
      <el-form-item label="版本号：" prop="versionName" class="width100">
        <el-input v-model="form.versionName" placeholder="请输入版本号"></el-input>
      </el-form-item>
      <el-form-item label="版本名称：" prop="versionNumber" class="width100">
        <el-input v-model="form.versionNumber" placeholder="请输入版本名称"></el-input>
      </el-form-item>
      <el-form-item label="版本code：" prop="versionCode" class="width100">
        <el-input v-model="form.versionCode" placeholder="请输入版本code"></el-input>
      </el-form-item>
      <el-form-item label="系统类型：" prop="versionType" class="width100">
        <el-radio-group v-model="form.versionType">
          <el-radio :label="1">安卓</el-radio>
          <el-radio :label="2">ios</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否强制更新：" prop="escalationState" class="width100">
        <el-switch v-model="form.escalationState" :active-value="1" :inactive-value="0"></el-switch>
      </el-form-item>
      <el-form-item label="安装包：" prop="versionUrl" class="width100">
        <el-upload class="upload-demo" :action=uploadUrl :limit="1" :on-success="handleSuccess" :on-remove="handleRemove" :on-progress="handleProgress">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <el-progress v-if="uploadProgress > 0" :percentage="uploadProgress" :status="uploadProgress === 100 ? 'success' : undefined" style="margin-top: 10px;"></el-progress>
        <el-input v-model="form.versionUrl"></el-input>
      </el-form-item>
      <el-form-item label="更新内容说明：" prop="updateDescription" class="width100">
        <el-input v-model="form.updateDescription" placeholder="请输入更新说明"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import appVersionApi from '@/api/system/appVersion'
function initFormBean() {
  const formBean = {
    escalationState: 0,
    versionType: 1,
    updateDescription: '',
    versionName: '',
    versionCode: '',
    versionNumber: '',
    versionUrl: '',
    versionSize: ''
  }
  return formBean
}

export default {
  props: ['popType'],
  //popType 0:新增 1:编辑
  data() {
    return {
      uploadUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload',
      titleList: ['添加版本', '编辑版本'],
      form: initFormBean(),
      formVisible: false,
      uploadProgress: 0,
      formRules: {
        versionName: [{ required: true, message: '请输入版本名称', trigger: 'blur' }],
        versionCode: [{ required: true, message: '请输入版本code', trigger: 'blur' }],
        versionNumber: [{ required: true, message: '请输入版本号', trigger: 'blur' }],
        versionUrl: [{ required: true, message: '请上传版本文件', trigger: 'blur' }],
        escalationState: [{ required: true, message: '请选择是否强制更新', trigger: 'change' }],
        versionType: [{ required: true, message: '请选择系统类型', trigger: 'change' }]
      },
    }
  },
  created() {

  },
  methods: {
    resetForm() {
      this.form = initFormBean()
      this.uploadProgress = 0
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(data) {
      this.resetForm()
      this.form = { ...data.row }
      this.form.escalationState = data.row.escalationState == 1 ? 1 : 0;
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 提交表单
     */
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let params = { ...this.form };
          if (this.form.id > 0) {
            appVersionApi.update(params).then((data) => {
              this.postCallback(data)
            });
          } else {
            appVersionApi.create(params).then((data) => {
              this.postCallback(data)
            });
          }
        }
      });
    },
    /**
     * 回调
     */
    postCallback(response) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
    // 文件上传进度
    handleProgress(event, file) {
      // 确保进度不超过99%，避免在上传完成前显示100%
      this.uploadProgress = Math.min(Math.round(event.percent), 99);
    },
    // 文件上传成功
    handleSuccess(response, file) {
      this.form.versionUrl = response.data;
      this.form.versionSize = (file.size / (1024 * 1000)).toFixed(2);
      // 设置为100%显示成功状态
      this.uploadProgress = 100;
      // 延迟隐藏进度条，让用户看到成功状态
      setTimeout(() => {
        this.uploadProgress = 0;
      }, 2000);
    },
    // 文件删除成功
    handleRemove(file) {
      this.form.versionUrl = '';
      this.uploadProgress = 0;
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.reward-type {
  display: flex;
  & > .el-select {
    &:first-child {
      width: 180px;
      margin-right: 10px;
    }
  }
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-upload-list {
  display: none;
}
</style>